export default __webpack_public_path__ + "static/media/P2_Micropipette.9a8426a6.svg";